import {ChangeDetectionStrategy, Component, computed, inject, input} from '@angular/core';
import {AppNumberPipe, formatAppNumber} from '@frontend/shared';
import {TranslocoPipe, TranslocoService} from '@jsverse/transloco';
import {RfpCriterionResult} from '../../rfp-individual-results.types';

@Component({
  selector: 'app-rfp-criterion-header',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AppNumberPipe, TranslocoPipe],
  host: {class: 'flex w-full flex-wrap items-center justify-between gap-x-4 gap-y-1 pr-4'},
  templateUrl: './rfp-criterion-header.component.html',
})
export class RfpCriterionHeaderComponent {
  private readonly translocoService = inject(TranslocoService);

  readonly criterion = input.required<RfpCriterionResult>();

  protected readonly scored = computed(() => this.criterion().percentage !== null);
  protected readonly weightPercent = computed(() => (this.criterion().weight ?? 0) * 100);
  protected readonly hasWeight = computed(() => this.criterion().weight !== null);
  protected readonly hasDeviation = computed(() => this.criterion().deviation !== null);
  protected readonly deviationParams = computed(() => {
    const deviation = this.criterion().deviation ?? 0;
    const formatted = formatAppNumber(
      Math.abs(deviation),
      this.translocoService.getActiveLang(),
      '1.0-0',
    );
    return {deviation: `${deviation < 0 ? '−' : '+'}${formatted}`};
  });
  protected readonly deviationClass = computed(() =>
    (this.criterion().deviation ?? 0) < 0 ? 'text-red' : 'text-green',
  );
}
